import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Дев-фрейм (сужение окна до 450px на десктопе для предпросмотра мобильного вида) включаем только вне
// продакшена: класс `dev-frame` активирует стили в global.scss. Флаг `production` здесь непригоден
// (он true и на dev), поэтому ориентируемся на environmentName.
if (environment.environmentName !== 'production') {
  document.documentElement.classList.add('dev-frame');
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => {
    // eslint-disable-next-line no-console
    console.log(err);
  });
